// Client wrapper for the persistent drafts API. A draft holds the staged
// assignments + date window so schedule-building survives reload/logout.

import type { GuideRef } from "@/lib/load";

export interface DraftPayload {
  staged: Record<string, GuideRef>; // pageId -> guide
  from: string;
  to: string;
  notes?: string;
}

export interface DraftMeta {
  id: number;
  name: string;
  updated_by: string | null;
  updated_at: string;
  created_at: string;
}

export interface DraftFull extends DraftMeta {
  payload: DraftPayload;
}

export async function listDrafts(): Promise<DraftMeta[]> {
  const res = await fetch("/api/drafts");
  if (!res.ok) throw new Error(`list drafts ${res.status}`);
  const data = (await res.json()) as { drafts?: DraftMeta[] };
  return data.drafts || [];
}

export async function saveDraft(
  name: string,
  payload: DraftPayload,
  id?: number,
): Promise<{ id: number; updated_at: string }> {
  const res = await fetch("/api/drafts", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, name, payload }),
  });
  if (!res.ok) throw new Error(`save draft ${res.status}`);
  return res.json();
}

export async function loadDraft(id: number): Promise<DraftFull> {
  const res = await fetch(`/api/drafts/${id}`);
  if (!res.ok) throw new Error(`load draft ${res.status}`);
  return res.json();
}

export async function deleteDraft(id: number): Promise<void> {
  const res = await fetch(`/api/drafts/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`delete draft ${res.status}`);
}
